/**
 * 选择了global， 则展示Global
 * 选择了global_wo_china ，则展示Global Except China Mainland
 * 不是上面2种情况，如果是单选国家，则不展示Total
 */
export enum MarketsType {
  Global = 'Global',
  GlobalWoChina = 'GlobalWoChina',
  SimpleMarket = 'SimpleMarket',
  Others = 'Others',
}
export function getMaketsType(regions: string[], markets: string[]) {
  if (Array.isArray(regions) && regions?.length > 0) {
    if (regions[0]?.toLowerCase() === 'global') {
      return MarketsType.Global;
    }
    if (regions[0]?.toLowerCase() === 'global_wo_china') {
      return MarketsType.GlobalWoChina;
    }
  }
  // 上面的不成立则判断下面的， 2个不存在if else关系
  if (Array.isArray(markets) && markets?.length === 1) {
    return MarketsType.SimpleMarket;
  }
  return MarketsType.Others;
}
export interface TopListProp {
  total: {};
  global: {};
  globalWoChina: {};
  list: any[];
}
// 获取计算others的
export function getCalOtherList(marketType: MarketsType, topList: TopListProp) {
  switch (marketType) {
    case MarketsType.Global:
      return topList?.global;
    case MarketsType.GlobalWoChina:
      return topList?.globalWoChina;
    case MarketsType.Others:
    default:
      return topList?.total;
  }
}

export function getTopList(tableList: any[]): TopListProp {
  if (!tableList || tableList?.length === 0) {
    return {
      total: {},
      global: {},
      globalWoChina: {},
      list: tableList,
    };
  }

  const _tableList = tableList?.slice(0);
  let total = {};
  let global = {};
  let globalWoChina = {};

  for (let i = 0; i < _tableList?.length; i++) {
    const item = _tableList[i];
    if (
      item?.market?.toLocaleLowerCase() === 'global' ||
      item?.name?.toLocaleLowerCase() === 'global'
    ) {
      global = item;
      global.name = 'Global';
      _tableList.splice(i, 1);
      i--; // 删除则回退一个
    }
    if (
      item?.market?.toLocaleLowerCase() === 'global_wo_china' ||
      item?.name?.toLocaleLowerCase() === 'global_wo_china'
    ) {
      globalWoChina = item;
      globalWoChina.name = 'Global Except China Mainland';
      _tableList.splice(i, 1);
      i--;
    }
    if (
      item?.market?.toLocaleLowerCase() === 'total' ||
      item?.name?.toLocaleLowerCase() === 'total'
    ) {
      total = item;
      total.name = 'Total';
      _tableList.splice(i, 1);
      i--;
    }
    // global , total ，globalExecptchina只会在前三
    // 因后端不一定就返回在前三， 所以还是全部遍历比较好
    // if (i === 2) break;
  }

  return {
    total,
    global,
    globalWoChina,
    list: _tableList,
  };
}
/** 获取固定在第一/第二行的数据 */
export const getFixedTableData = (marketType: MarketsType, topList: TopListProp) => {
  if (
    JSON.stringify(topList?.total) === '{}' &&
    JSON.stringify(topList?.global) === '{}' &&
    JSON.stringify(topList?.globalWoChina) === '{}'
  ) {
    return [];
  }
  const firstList = [];
  if (marketType === MarketsType.Global) {
    if (topList?.globalWoChina && JSON.stringify(topList?.globalWoChina) !== '{}') {
      firstList?.unshift({
        ...(topList?.globalWoChina || {}),
        name: 'Global Except China Mainland',
        market: 'global_wo_china',
      });
    }
    if (topList?.global && JSON.stringify(topList?.global) !== '{}') {
      firstList?.unshift({
        ...(topList?.global || {}),
        name: 'Global',
        market: 'global',
      });
    }
  } else if (marketType === MarketsType.GlobalWoChina) {
    if (topList?.globalWoChina && JSON.stringify(topList?.globalWoChina) !== '{}') {
      firstList?.unshift({
        ...(topList?.globalWoChina || {}),
        name: 'Global Except China Mainland',
        market: 'global_wo_china',
      });
    }
  } else if (marketType === MarketsType.Others) {
    if (topList?.total && JSON.stringify(topList?.total) !== '{}') {
      firstList?.unshift({
        ...(topList?.total || {}),
        name: 'Total',
        market: 'total',
      });
    }
  }
  return firstList;
};
